import React from 'react';
import PropTypes from 'prop-types';
import Button from '@strava/ui/Button';

const IconButton = ({
  children,
  onClick,
  ariaLabel,
  className,
  ...options
}) => {
  return (
    <Button
      variant="icon"
      type="button"
      onClick={onClick}
      aria-label={ariaLabel}
      className={className}
      {...options}
    >
      {children}
    </Button>
  );
};

IconButton.defaultProps = {
  className: null
};

IconButton.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
  ariaLabel: PropTypes.string.isRequired,
  className: PropTypes.string
};

export default IconButton;
